import { Component } from '@angular/core';
import { SearchService } from '../../search/search.service';
import { SearchStatus } from '../../search/models/search-status.model';
import { SearchParams } from '../../search/models/search-params.model';
import { ResourceService } from 'sce-core';
import { SharedServiceRegistry } from '../../shared-service-registry';

@Component({
  selector: 'lfwms-lookup-popup',
  templateUrl: './lookup-popup.component.html',
  styleUrls: ['./lookup-popup.component.css']
})
export class LookupPopupComponent {
  public searchAccordionTitle;
  public lookupParams: SearchParams;
  public lookupStatus: SearchStatus;
  public lookupService: SearchService;
  public hideOnSearch: boolean = false;
  // LFWM-2625 - lookup alignment changes
  public isLookup: boolean = true;

  constructor(protected resourceService: ResourceService,
    protected sharedServiceRegistry: SharedServiceRegistry) {
  }

  public initializeComponents(lookupParams: SearchParams,
      lookupStatus: SearchStatus, lookupCriteria: any, dataEditor?: any,subheader?:any) {
    this.lookupParams = lookupParams;
    this.lookupParams.tableEditor = dataEditor;
    this.lookupService = this.sharedServiceRegistry
      .createSearchService(lookupParams, lookupStatus);
    this.lookupStatus = this.lookupService.searchStatus;
    this.lookupService.setSearchCriteria(lookupCriteria);
    this.searchAccordionTitle = subheader ? subheader : '';
  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/1_SCE_CI_CD_SIT/src/app/shared/lookup/popup/lookup-popup.component.ts